import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { RoomContainer } from './container';
import { RoomDetailV2 } from './v2';
import { RoomProps } from './Room.types';

export const RoomVersion: FC<RoomProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <RoomDetailV2 {...props} />;
  return <RoomContainer {...props} />;
};
